import { composeRequestKey } from "./composeRequestKey";

export const getClientQueryKey = () => composeRequestKey({ name: "client" });

export const getClientsArrQueryKey = () => composeRequestKey({ name: "clients" });

export const getAppointmentsQueryKey = () => composeRequestKey({ name: "appointments" });

export const getClubsQueryKey = () => composeRequestKey({ name: "clubs" });

export const postAuthClientsKey = () => composeRequestKey({ name: "auth_clients" });

export const getTicketsQueryKey = () => composeRequestKey({ name: "tickets" });

export const getClosedTicketsQueryKey = () => composeRequestKey({ name: "closed_tickets" });

export const getPurchaseHistoryQueryKey = () => composeRequestKey({ name: "purchase" });

export const getBonusesQueryKey = () => composeRequestKey({ name: "bonuses" });

export const getVisitsHistoryQueryKey = () => composeRequestKey({ name: "visits_history" });

export const getSwimmersDiaryQueryKey = () => composeRequestKey({ name: "swimmers_diary" });

export const getAppointmentServicesQuery = (clubId?: string) =>
  composeRequestKey({ name: "appointment_services", filters: clubId ? { clubId } : undefined });

export const getDepositsQueryKey = () => composeRequestKey({ name: "deposits" });

export const getTrainersQueryKey = () => composeRequestKey({ name: "trainers" });

export const getDatesQueryKey = () => composeRequestKey({ name: "dates" });

export const getSlotsQueryKey = () => composeRequestKey({ name: "slots" });

export const getClubInfoQueryKey = () => composeRequestKey({ name: "club_info" });

export const getPriceListQueryKey = (clubId: string) =>
  composeRequestKey({ name: "price_list", filters: { clubId } });

export const getCartCostQueryKey = (clubId: string, cartHash: string) =>
  composeRequestKey({ name: "cart_cost", filters: { clubId, cartHash } });

// Freeze applications (NocoBase)
export const getFreezeApplicationsQueryKey = () =>
  composeRequestKey({ name: "freeze_applications" });

// Refund applications (NocoBase)
export const getRefundApplicationsQueryKey = () =>
  composeRequestKey({ name: "refund_applications" });

// Same-day cancellations (NocoBase)
export const getSameDayCancellationsQueryKey = () =>
  composeRequestKey({ name: "same_day_cancellations" });

export const getCoursesQueryKey = (clubId?: string) =>
  composeRequestKey({ name: "courses", filters: clubId ? { clubId } : undefined });

export const getCourseDescriptionQueryKey = (courseId: string) =>
  composeRequestKey({ name: "course_description", filters: { courseId } });

export const getClientCoursesQueryKey = () => composeRequestKey({ name: "client_courses" });

export const getCourseClassesQueryKey = (clubId: string, startDate: string, endDate: string) =>
  composeRequestKey({
    name: "course_classes",
    filters: { clubId, startDate, endDate },
  });
